import { motion } from 'framer-motion'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { getDashboardVariants } from '@/components/Dashboard/dashboardMotion'

export function DashboardSkeleton() {
  const v = getDashboardVariants(false)

  return (
    <DashboardLayout title='Dashboard'>
      <motion.div
        variants={v.container}
        initial='hidden'
        animate='show'
        className='flex flex-col gap-6'
      >
        <motion.div variants={v.item} className='h-11 w-full max-w-xl rounded-xl bg-white/[0.04] animate-pulse' />
        <div className='grid grid-cols-2 lg:grid-cols-4 gap-4'>
          {[...Array(4)].map((_, i) => (
            <motion.div
              key={i}
              variants={v.kpiItem}
              className='glass-card animate-pulse p-5'
            >
              <div className='h-3 w-20 bg-white/10 rounded mb-3' />
              <div className='h-7 w-28 bg-white/10 rounded mb-2' />
              <div className='h-3 w-16 bg-white/10 rounded' />
            </motion.div>
          ))}
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-5 gap-4'>
          <motion.div variants={v.item} className='lg:col-span-3 glass-card animate-pulse p-6'>
            <div className='h-5 w-32 bg-white/10 rounded mb-4' />
            {[...Array(5)].map((_, i) => (
              <div key={i} className='h-7 bg-white/5 rounded-md mb-2' />
            ))}
          </motion.div>
          <motion.div variants={v.item} className='lg:col-span-2 glass-card animate-pulse p-6'>
            <div className='h-5 w-32 bg-white/10 rounded mb-4' />
            {[...Array(5)].map((_, i) => (
              <div key={i} className='flex items-center gap-3 mb-3'>
                <div className='w-7 h-7 rounded-full bg-white/10' />
                <div className='flex-1'>
                  <div className='h-3 w-24 bg-white/10 rounded mb-1' />
                  <div className='h-2 w-16 bg-white/10 rounded' />
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </motion.div>
    </DashboardLayout>
  )
}
